<template>
  <div class="page">
    <div class="page_head">
      <ul class="nav">
        <li v-for="(item, index) in navItems" :key="index" :class="{ title: true, active: activeIndex === index }" @click="setActive(index)">
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="main_theme" id="home">
      <div class="title"></div>
      <div class="describe">NeMo: <u>Ne</u>edle in a <u>Mo</u>ntage <br />for Video-Language Understanding</div>
      <!-- <br /><br /> -->
      <div class="institution_describe">
        Zi-Yuan Hu<sup>&dagger;1</sup>, Shuo Liang<sup>&dagger;1</sup>, Duo Zheng<sup>1</sup>, Yanyang Li<sup>1</sup>, Yeyao Tao<sup>1</sup>, Shijia Huang<sup>1</sup>, <br />
        Wei Feng<sup>2</sup>, Jia Qin<sup>2</sup>, Jianguang Yu<sup>2</sup>, Jing Huang<sup>3</sup>, Meng Fang<sup>4</sup>, Yin Li<sup>5</sup>, Liwei Wang<sup>*1</sup>
      </div>
      <!-- <br /> -->
      <div class="institution_describe institution_describe_bottom">
        <sup>1</sup>The Chinese University of Hong Kong&nbsp;&nbsp; <sup>2</sup>Phoenix TV<br />
        <sup>3</sup>Standford University&nbsp;&nbsp; <sup>4</sup>University of Liverpool&nbsp;&nbsp; <sup>5</sup>University of Wisconsin-Madison<br />
        <sup>&dagger;</sup>Equal Contributions&nbsp;&nbsp; <sup>*</sup>Project Lead & Corresponding Author
      </div>
      <div class="institution"></div>
      <div class="button_group">
        <div class="btn lf" @click="setActive(3)">Leaderboard</div>
        <a
          href="https://arxiv.org/abs/2509.24563"
          target="_blank"
          class="btn rt"
          style="text-decoration: none !important"
          >Technical Report</a
        >
      </div>
      <div class="arrow" @click="setActive(1)"></div>
    </div>
    <div class="news_column" id="whats-new">
      <div class="title">What's New</div>
      <ul class="new_list">
        <li v-for="(item, index) in newList" :key="index">
          <div class="order">
            <div class="num">{{ item.num }}</div>
            <div class="numDate">{{ item.numDate }}</div>
          </div>
          <div class="info">{{ item.info }}</div>
        </li>
      </ul>
    </div>
    <div class="card_flex" id="overview">
      <div class="titleInfo">Overview</div>
      <div class="card_list">
        <div class="item" v-for="(item, index) in cardList" :key="index">
          <img class="iconImg" :src="require(`../assets/images/${item.iconImg}`)" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>

    <div class="leaderboardShort" id="leaderboards">
      <div class="title">Leaderboard (Short Montages)</div>
      <ul class="tabList">
        <li :class="{ active: activeTabShort === 0 }" @click="setActiveTabShort(0)"><b></b>Form</li>
        <li :class="{ active: activeTabShort === 1 }" @click="setActiveTabShort(1)"><b></b>Chart</li>
      </ul>
      <div class="board_tabs_Short">
        <div class="item" v-if="activeTabShort === 0">
          <el-table
            class="board_table"
            :data="tableDataShort"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%; height: 680px"
            max-height="680"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="170"></el-table-column>
            <el-table-column label="Short Object Needle Grounding">
              <el-table-column
                prop="objRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column label="Short Scene Needle Grounding">
              <el-table-column
                prop="sceneRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="sceneRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              prop="Avg"
              sortable
              :render-header="renderHeader('Avg Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
              width="150"
              :formatter="formatNumber"
            ></el-table-column>
          </el-table>
        </div>
        <div class="item" v-if="activeTabShort === 1">
          <LineChartShort></LineChartShort>
        </div>
      </div>
    </div>

    <div class="leaderboardMedium">
      <div class="title">Leaderboard (Medium Montages)</div>
      <ul class="tabList">
        <li :class="{ active: activeTabMedium === 0 }" @click="setActiveTabMedium(0)"><b></b>Form</li>
        <li :class="{ active: activeTabMedium === 1 }" @click="setActiveTabMedium(1)"><b></b>Chart</li>
      </ul>
      <div class="board_tabs_Medium">
        <div class="item" v-if="activeTabMedium === 0">
          <el-table
            class="board_table"
            :data="tableDataMedium"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%; height: 680px"
            max-height="680"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="170"></el-table-column>
            <el-table-column label="Medium Object Needle Grounding">
              <el-table-column
                prop="objRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column label="Medium Scene Needle Grounding">
              <el-table-column
                prop="sceneRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="sceneRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              prop="Avg"
              sortable
              :render-header="renderHeader('Avg Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
              width="150"
              :formatter="formatNumber"
            ></el-table-column>
          </el-table>
        </div>
        <div class="item" v-if="activeTabMedium === 1">
          <LineChartMedium></LineChartMedium>
        </div>
      </div>
    </div>

    <div class="leaderboardLong">
      <div class="title">Leaderboard (Long Montages)</div>
      <ul class="tabList">
        <li :class="{ active: activeTabLong === 0 }" @click="setActiveTabLong(0)"><b></b>Form</li>
        <li :class="{ active: activeTabLong === 1 }" @click="setActiveTabLong(1)"><b></b>Chart</li>
      </ul>
      <div class="board_tabs_Long">
        <div class="item" v-if="activeTabLong === 0">
          <el-table
            class="board_table"
            :data="tableDataLong"
            :default-sort="{ prop: 'Avg', order: 'descending' }"
            style="width: 100%; height: 620px"
            max-height="620"
            @sort-change="handleSortChange"
          >
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="methods" :render-header="renderHeader('Methods')" width="170"></el-table-column>
            <el-table-column label="Long Object Needle Grounding">
              <el-table-column
                prop="objRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="objmAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column label="Long Scene Needle Grounding">
              <el-table-column
                prop="sceneRecall07"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="sceneRecall05"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.5')"
                :formatter="formatNumber"
              >
              </el-table-column>
              <el-table-column
                prop="scenemAP"
                sortable
                :render-header="renderHeader('&nbsp;&nbsp;&nbsp;&nbsp;Average<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;mAP')"
                :formatter="formatNumber"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              prop="Avg"
              sortable
              :render-header="renderHeader('Avg Recall@1x,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tIoU=0.7')"
              width="150"
              :formatter="formatNumber"
            ></el-table-column>
          </el-table>
        </div>
        <div class="item" v-if="activeTabLong === 1">
          <LineChartLong></LineChartLong>
        </div>
      </div>
    </div>
    <div class="content_text_image" id="evaluation">
      <div class="title">Evaluation</div>
      <div class="news_topic">
      We welcome all researchers to evaluate their models on our NeMoBench. 
      Our benchmark and model evaluation service will be made publicly available on requests for research purposes.          
      Please contact us at lavilabcuhk@gmail.com.
      <br><br>

      <!-- Please note that NeMoBench is distributed under the <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank" style="text-decoration: underline; color: #EFEFEF;">Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License</a>.  -->
      By using this dataset for evaluation, you agree to the terms and conditions of the license.
      You should acknowledge and understand that: 
      <ul style="list-style-type: disc; padding-left: 20px; list-style-color: #FFFFFF;">
        <li>- NeMoBench is for non-commercial academic use ONLY. </li>
        <li>- NeMoBench is for model evaluation ONLY. </li>
        <li>- NeMoBench MUST NOT be used for other purposes, including but not limited to model training or video editing.</li>
        <li>- You are required to use the dataset ethically and in compliance with all applicable laws and regulations.</li>
      </ul>
      </div>
    </div>

    <div class="benchmark_example" id="nemobench-examples">
      <div class="title">Examples of Needle in a Montage</div>
      <div class="cont_task">
        <ul class="left_nav">
          <li v-for="(item, index) in leftNavList" :key="index" :class="{ title: true, active: navIndex === index }" @click="navActive(index)">{{ item }}</li>
        </ul>
        <div class="right_box">
          <ul class="example_ul">
            <li v-for="(item, index) in exampleList" :key="index" :class="{ active: exampleIndex === index }" @click="exampleActive(index)">{{ item }}</li>
          </ul>
          <div class="example_inner">
            <video :src="currentExample.video" :poster="currentExample.poster" controls class="example_video"></video>
            <div class="example_choice">
              <div class="topic">Question:<br />{{ currentExample.question }}</div>
              <div class="topic" v-html="currentExample.answer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="contact_info" id="contact">
      <div class="information">{{ information }}</div>
      <div class="mail">{{ mail }}</div>
    </div>
    <div class="page_footer">
      <div class="footer">Copyright &copy; LaViLab & PhoenixTV</div>
    </div>
  </div>
</template>

<script>
import LineChartShort from "./pcComponent/LineChartShort.vue";
import LineChartMedium from "./pcComponent/LineChartMedium.vue";
import LineChartLong from "./pcComponent/LineChartLong.vue";
export default {
  name: "PcComponent",
  components: { LineChartShort, LineChartMedium, LineChartLong },
  data() {
    return {
      activeLang: "en", // 初始语言设置为英文
      activeTab: 0, // 切换导航
      activeTabShort: 0,
      activeTabMedium: 0,
      activeTabLong: 0,
      navIndex: 0, // 垂直导航默认选中项
      navItems: ["Home", "What's New", "Overview", "Leaderboards", "Evaluation", "Examples", "Contact"],
      activeIndex: 0,
      newList: [
        {
          num: "29",
          numDate: "2025-09",
          info: "We have publicly released our technical report! 🔥",
        },
      ],
      cardList: [
        {
          iconImg: "icon4.png",
          title: "Our Task: Needle in a Montage",
          text: "We introduce a novel task of Needle in a Montage (NeMo), which is designed to assess the critical video reasoning capabilities of Video Large Language Models (VideoLLMs), including long-context recall and temporal grounding. Specifically, our task embeds one or more needles (i.e., short video clips) within a montage (i.e., a long video) composed from many loosely related clips, where models must retrieve each individual needle by identifying its temporal extent.",
        },
        {
          iconImg: "icon2.png",
          title: "Our Automatic Data Generation Pipeline",
          text: "To generate video question answering data for our NeMo task, we first propose a comprehensive yet compact video representation, which follows a hierarchical structure enriched with semantic features, incorporating scene-level and object-level features. We then develop a scalable automatic data generation pipeline that effectively leverages the extracted video representations to facilitate high-quality data synthesis. Please refer to our technical report for more details.",
        },
        {
          iconImg: "icon1.png",
          title: "Our Benchmark: NeMoBench",
          text: "Built upon the proposed automatic pipeline, we present NeMoBench, a video-language benchmark centered on our NeMo task. Specifically, our benchmark includes two key components: (1) NeMoBench-Full: a comprehensive set comprising 31,378 automatically generated QA pairs about objects and scenes from 13,486 videos of varying durations, and (2) NeMoBench-Clean: a core subset containing 2,053 manually verified QA pairs from 950 videos, with durations ranging from seconds to hours.",
        },
        {
          iconImg: "icon3.png",
          title: "Experimental Results",
          // text: 'Our experiments yield several key findings: <br>(1) Our benchmark presents a major challenge for SoTA models across various task settings, demonstrating a significant gap between model and human performance; <br>(2) xx.',
          text: "Our experimental results demonstrate that the proposed task presents substantial challenges for both open-source and closed-source models, with a significant performance gap compared to human benchmarks across various montage durations. Moreover, we observe that model performance rankings remain consistent across both NeMoBench-Clean and NeMoBench-Full, demonstrating that our pipeline can reliably and automatically generate high-quality evaluation data. ",
        },
      ],
      information: "Contact Information",
      mail: "Contact us: lavilabcuhk@gmail.com",
      NeMoBench: {
        title: "About NeMoBench",
        text: "\n",
      },
      phoenix: {
        title: "About Phoenix TV",
        text: "\n",
      },
      tableDataShort: [
        {
          methods: "LLaVA-Video-7B",
          objRecall07: 1.1,
          objRecall05: 1.9,
          objmAP: 11.27,
          sceneRecall07: 2.34,
          sceneRecall05: 4.07,
          scenemAP: 19.48,
          Avg: 1.72,
        },
        {
          methods: "LongVA-7B",
          objRecall07: 1.2,
          objRecall05: 4.49,
          objmAP: 18.19,
          sceneRecall07: 2.54,
          sceneRecall05: 6.51,
          scenemAP: 21.87,
          Avg: 1.87,
        },
        {
          methods: "VILA1.5-13B",
          objRecall07: 0.8,
          objRecall05: 1.9,
          objmAP: 4.72,
          sceneRecall07: 3.36,
          sceneRecall05: 6.21,
          scenemAP: 14.77,
          Avg: 2.08,
        },
        {
          methods: "Oryx-34B",
          objRecall07: 2.69,
          objRecall05: 8.88,
          objmAP: 34.95,
          sceneRecall07: 5.39,
          sceneRecall05: 13.84,
          scenemAP: 41.4,
          Avg: 4.04,
        },
        {
          methods: "MiniCPM v2.6-8B",
          objRecall07: 4.49,
          objRecall05: 10.68,
          objmAP: 36.94,
          sceneRecall07: 3.87,
          sceneRecall05: 12.61,
          scenemAP: 41.75,
          Avg: 4.18,
        },
        {
          methods: "VILA1.5-40B",
          objRecall07: 4.49,
          objRecall05: 10.88,
          objmAP: 27.5,
          sceneRecall07: 6.82,
          sceneRecall05: 16.68,
          scenemAP: 40.84,
          Avg: 5.66,
        },
        {
          methods: "Moment-DETR",
          objRecall07: 7.09,
          objRecall05: 17.17,
          objmAP: 40.78,
          sceneRecall07: 10.38,
          sceneRecall05: 23.19,
          scenemAP: 51.2,
          Avg: 8.74,
        },
        {
          methods: "LLaVA-Video-72B",
          objRecall07: 8.88,
          objRecall05: 18.36,
          objmAP: 40.4,
          sceneRecall07: 12.31,
          sceneRecall05: 22.08,
          scenemAP: 41.89,
          Avg: 10.6,
        },
        {
          methods: "E.T. Chat-3.8B",
          objRecall07: 9.72,
          objRecall05: 21.54,
          objmAP: 38.23,
          sceneRecall07: 14.94,
          sceneRecall05: 26.82,
          scenemAP: 45.56,
          Avg: 12.33,
        },
        {
          methods: "UniVTG",
          objRecall07: 13.0,
          objRecall05: 24.7,
          objmAP: 53.16,
          sceneRecall07: 19.65,
          sceneRecall05: 34.42,
          scenemAP: 64.19,
          Avg: 16.33,
        },
        {
          methods: "LongVU-7B",
          objRecall07: 15.37,
          objRecall05: 31.44,
          objmAP: 63.06,
          sceneRecall07: 19.43,
          sceneRecall05: 34.18,
          scenemAP: 68.48,
          Avg: 17.4,
        },
        {
          methods: "Time-R1-3B",
          objRecall07: 15.27,
          objRecall05: 32.53,
          objmAP: 63.84,
          sceneRecall07: 22.38,
          sceneRecall05: 40.18,
          scenemAP: 72.85,
          Avg: 18.82,
        },
        {
          methods: "Time-R1-7B",
          objRecall07: 22.36,
          objRecall05: 38.02,
          objmAP: 68.25,
          sceneRecall07: 29.79,
          sceneRecall05: 44.86,
          scenemAP: 74.76,
          Avg: 26.03,
        },
        {
          methods: "Qwen2.5-VL-7B",
          objRecall07: 24.45,
          objRecall05: 32.63,
          objmAP: 57.22,
          sceneRecall07: 29.7,
          sceneRecall05: 41.71,
          scenemAP: 65.62,
          Avg: 27.08,
        },
        {
          methods: "Qwen2.5-VL-72B",
          objRecall07: 28.04,
          objRecall05: 37.62,
          objmAP: 61.01,
          sceneRecall07: 31.11,
          sceneRecall05: 43.13,
          scenemAP: 66.66,
          Avg: 29.69,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 41.86,
          objRecall05: 50.85,
          objmAP: 73.89,
          sceneRecall07: 55.7,
          sceneRecall05: 63.44,
          scenemAP: 82.38,
          Avg: 48.78,
        },
        {
          methods: "Qwen-VL-Max",
          objRecall07: 54.46,
          objRecall05: 63.69,
          objmAP: 82.77,
          sceneRecall07: 56.63,
          sceneRecall05: 64.8,
          scenemAP: 83.03,
          Avg: 55.55,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 62.64,
          objRecall05: 73.73,
          objmAP: 85.24,
          sceneRecall07: 72.1,
          sceneRecall05: 81.26,
          scenemAP: 90.15,
          Avg: 67.37,
        },
        {
          methods: "GPT-4o",
          objRecall07: 64.07,
          objRecall05: 74.85,
          objmAP: 88.56,
          sceneRecall07: 71.41,
          sceneRecall05: 81.18,
          scenemAP: 89.91,
          Avg: 67.74,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 65.83,
          objRecall05: 78.22,
          objmAP: 89.81,
          sceneRecall07: 74.85,
          sceneRecall05: 85.54,
          scenemAP: 92.85,
          Avg: 70.34,
        },
        {
          methods: "Human Experts",
          objRecall07: 93.62,
          objRecall05: 96.1,
          objmAP: 95.31,
          sceneRecall07: 94.33,
          sceneRecall05: 95.39,
          scenemAP: 96.31,
          Avg: 93.98,
        },
      ],
      tableDataMedium: [
        {
          methods: "MiniCPM v2.6-8B",
          objRecall07: 0.23,
          objRecall05: 0.68,
          objmAP: 4.79,
          sceneRecall07: 0.74,
          sceneRecall05: 2.22,
          scenemAP: 6.48,
          Avg: 0.49,
        },
        {
          methods: "Time-R1-3B",
          objRecall07: 0.45,
          objRecall05: 1.36,
          objmAP: 4.27,
          sceneRecall07: 0.74,
          sceneRecall05: 2.47,
          scenemAP: 5.81,
          Avg: 0.6,
        },
        {
          methods: "LongVU-7B",
          objRecall07: 0.68,
          objRecall05: 1.82,
          objmAP: 3.56,
          sceneRecall07: 1.23,
          sceneRecall05: 2.22,
          scenemAP: 4.05,
          Avg: 0.96,
        },
        {
          methods: "E.T. Chat-3.8B",
          objRecall07: 0.76,
          objRecall05: 1.76,
          objmAP: 4.25,
          sceneRecall07: 1.62,
          sceneRecall05: 3.5,
          scenemAP: 6.27,
          Avg: 1.19,
        },
        {
          methods: "LLVA-Video-72B",
          objRecall07: 1.59,
          objRecall05: 2.5,
          objmAP: 6.82,
          sceneRecall07: 0.99,
          sceneRecall05: 2.96,
          scenemAP: 8.72,
          Avg: 1.29,
        },
        {
          methods: "Qwen2.5-VL-7B",
          objRecall07: 5.39,
          objRecall05: 7.49,
          objmAP: 21.25,
          sceneRecall07: 8.28,
          sceneRecall05: 13.45,
          scenemAP: 29.55,
          Avg: 6.83,
        },
        {
          methods: "Time-R1-7B",
          objRecall07: 7.95,
          objRecall05: 15.91,
          objmAP: 35.33,
          sceneRecall07: 11.88,
          sceneRecall05: 20.54,
          scenemAP: 44.95,
          Avg: 9.92,
        },
        {
          methods: "Qwen2.5-VL-72B",
          objRecall07: 8.86,
          objRecall05: 16.82,
          objmAP: 35.95,
          sceneRecall07: 13.58,
          sceneRecall05: 27.41,
          scenemAP: 51.35,
          Avg: 11.22,
        },
        {
          methods: "Qwen-VL-Max",
          objRecall07: 12.44,
          objRecall05: 16.67,
          objmAP: 34.16,
          sceneRecall07: 17.14,
          sceneRecall05: 21.23,
          scenemAP: 40.55,
          Avg: 14.79,
        },
        {
          methods: "GPT-4o",
          objRecall07: 24.32,
          objRecall05: 38.41,
          objmAP: 63.97,
          sceneRecall07: 28.64,
          sceneRecall05: 43.95,
          scenemAP: 69.75,
          Avg: 26.48,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 32.71,
          objRecall05: 40.71,
          objmAP: 59.0,
          sceneRecall07: 43.81,
          sceneRecall05: 53.35,
          scenemAP: 71.91,
          Avg: 38.26,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 41.41,
          objRecall05: 52.24,
          objmAP: 69.51,
          sceneRecall07: 55.41,
          sceneRecall05: 68.3,
          scenemAP: 81.85,
          Avg: 48.41,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 48.24,
          objRecall05: 58.35,
          objmAP: 74.3,
          sceneRecall07: 65.46,
          sceneRecall05: 75.77,
          scenemAP: 86.08,
          Avg: 56.85,
        },
        {
          methods: "Human Experts",
          objRecall07: 90.74,
          objRecall05: 88.89,
          objmAP: 91.87,
          sceneRecall07: 90.32,
          sceneRecall05: 89.25,
          scenemAP: 93.37,
          Avg: 90.53,
        },
      ],
      tableDataLong: [
        {
          methods: "Qwen-VL-Max",
          objRecall07: 0.94,
          objRecall05: 1.88,
          objmAP: 4.83,
          sceneRecall07: 0.95,
          sceneRecall05: 3.32,
          scenemAP: 7.12,
          Avg: 0.95,
        },
        {
          methods: "GPT-4o",
          objRecall07: 2.83,
          objRecall05: 7.29,
          objmAP: 23.2,
          sceneRecall07: 2.9,
          sceneRecall05: 7.88,
          scenemAP: 26.74,
          Avg: 2.87,
        },
        {
          methods: "Gemini-1.5-Flash-8B",
          objRecall07: 25.53,
          objRecall05: 34.04,
          objmAP: 47.63,
          sceneRecall07: 39.3,
          sceneRecall05: 44.54,
          scenemAP: 60.97,
          Avg: 32.42,
        },
        {
          methods: "Gemini-1.5-Flash-002",
          objRecall07: 40.43,
          objRecall05: 51.49,
          objmAP: 66.0,
          sceneRecall07: 54.15,
          sceneRecall05: 65.5,
          scenemAP: 75.49,
          Avg: 47.29,
        },
        {
          methods: "Gemini-1.5-Pro-002",
          objRecall07: 51.91,
          objRecall05: 60.85,
          objmAP: 73.45,
          sceneRecall07: 67.69,
          sceneRecall05: 72.05,
          scenemAP: 82.18,
          Avg: 59.8,
        },
        {
          methods: "Human Experts",
          objRecall07: 81.33,
          objRecall05: 85.33,
          objmAP: 90.67,
          sceneRecall07: 82.61,
          sceneRecall05: 85.51,
          scenemAP: 91.16,
          Avg: 81.97,
        },
      ],
      leftNavList: ["Short Montage", "Medium Montage", "Long Montage"],
      exampleList: ["Object Needle Grounding", "Scene Needle Grounding"],
      exampleIndex: 0,
      examplesData: {
        ExampleShortObject: {
          video: require("../assets/videos/short_object.mp4"),
          question: "When is green lawn in front of the palace displayed in the video?",
          answer: "Ground-truth answer: <br>00:00:05 - 00:00:08",
        },
        ExampleShortScene: {
          video: require("../assets/videos/short_scene.mp4"),
          question: "When was the scene with the vase in front of the mesh fence and plants shown in the video?",
          answer: "Ground-truth answer: <br>00:00:25 - 00:00:46",
        },
        ExampleMediumObject: {
          video: require("../assets/videos/medium_object.mp4"),
          poster: require("@/assets/videos/medium_object.jpg"),
          question: "At what time in the video is the traditional long robe worn by the individual holding a book visible?",
          answer: "Ground-truth answer: <br>00:01:13 - 00:01:19",
        },
        ExampleMediumScene: {
          video: require("../assets/videos/medium_scene.mp4"),
          question: "When does the scene of a panda sitting near a metal enclosure and looking upward appear in the video?",
          answer: "Ground-truth answer: <br>00:00:19 - 00:00:22, <br>00:00:28 - 00:00:32, <br>00:01:49 - 00:01:52",
        },
        ExampleLongObject: {
          video: require("../assets/videos/long_object_scene.mp4"),
          question: "When does the video feature a multi-tiered wooden pagoda?",
          answer: "Ground-truth answer: <br>00:03:44 - 00:03:47, <br>00:08:48 - 00:08:52, <br>00:11:54 - 00:11:58",
        },
        ExampleLongScene: {
          video: require("../assets/videos/long_object_scene.mp4"),
          question: "When does the scene of a man wearing glasses and a black leather jacket seated in front of a dark background appear in the video?",
          answer: "Ground-truth answer: <br>00:14:52 - 00:14:55, <br>00:21:18 - 00:21:22",
        },
      },
    };
  },
  computed: {
    currentMontage() {
      const types = ["Short", "Medium", "Long"];
      return types[this.navIndex];
    },
    currentTask() {
      return this.exampleIndex === 0 ? "Object" : "Scene";
    },
    currentExample() {
      return this.examplesData[`Example${this.currentMontage}${this.currentTask}`];
    },
  },
  watch: {},
  created() {},
  mounted() {
    // 初始化时执行一次默认排序
    this.handleSortChange({
      prop: "Avg",
      order: "descending",
    });
  },
  methods: {
    setActive(index) {
      this.activeIndex = index;
      const sections = ["home", "whats-new", "overview", "leaderboards", "evaluation", "nemobench-examples", "contact"];
      const sectionId = sections[index];
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 64; // 导航栏高度
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    },
    setActiveTabShort(index) {
      this.activeTabShort = index;
    },
    setActiveTabMedium(index) {
      this.activeTabMedium = index;
    },
    setActiveTabLong(index) {
      this.activeTabLong = index;
    },
    switchLanguage(lang) {
      this.activeLang = lang;
    },
    navActive(index) {
      this.navIndex = index;
    },
    exampleActive(index) {
      this.exampleIndex = index;
    },
    renderHeader(label) {
      return (h) => {
        return h("span", {
          domProps: {
            innerHTML: label,
          },
        });
      };
    },
    // 表格排序 { column, prop, order }
    handleSortChange({ column, prop, order }) {
      console.log(column);
      console.log(prop);
      console.log(order);
      // 升序排序
      if (order === "ascending") {
        this.tableDataLong.sort((a, b) => {
          if (typeof a[prop] === "string" && typeof b[prop] === "string") {
            return a[prop].localeCompare(b[prop]);
          }
          return a[prop] - b[prop];
        });
      } else if (order === "descending") {
        this.tableDataLong.sort((a, b) => {
          if (typeof a[prop] === "string" && typeof b[prop] === "string") {
            return b[prop].localeCompare(a[prop]);
          }
          return b[prop] - a[prop];
        });
      }
    },
    formatNumber(row, column, cellValue) {
      // 处理可能的字符串类型和空值
      const value = parseFloat(cellValue || 0);
      return value.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: rgba(10, 14, 22, 1);
  position: relative;
  width: 100%;
  // overflow: hidden;
  padding-top: 32px;
  .page_head {
    width: 100%;
    height: 64px;
    position: fixed; // 新增固定定位
    top: 0;
    background: rgba(10, 14, 22, 1); // 保持背景色一致
    z-index: 1000;
    border-bottom: 1px solid rgba(255, 255, 255, 0.13);
    display: flex;
    align-items: center;
    padding-right: pxToViewport.pxtovw(367px);
    justify-content: flex-end;
    .nav {
      display: flex;
      align-items: center;
      .title {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        margin-left: 33px;
        cursor: pointer;
        &.active {
          color: rgba(255, 255, 255, 1);
          font-family: PingFangSC-Semibold;
        }
      }
    }
    .language {
      display: flex;
      align-items: center;
      margin-left: 15px;
      color: rgba(164, 160, 158, 1);
      font-size: 14px;
      cursor: pointer;
      .active {
        color: rgba(255, 134, 83, 1);
        font-size: 14px;
      }
      b {
        margin: 0px 8px;
        cursor: default;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .main_theme {
    background: url("../assets/images/Background.svg") no-repeat center center;
    background-size: cover;
    width: 92%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px auto;
    position: relative;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 60px;
      color: #ffffff;
      // color: #FF621F;
      text-align: right;
      font-style: normal;
      margin-top: pxToViewport.pxtovw(117px);
      display: flex;
      align-items: center;
      overflow: hidden;
      line-height: 1;
    }
    .describe {
      width: 932px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 50px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      margin-top: pxToViewport.pxtovw(35px);
      overflow: hidden;
    }
    .institution {
      background: url("../assets/images/logo.png") no-repeat;
      background-size: 100% 100%;
      width: 470px;
      height: 60px;
      margin-top: pxToViewport.pxtovw(45px);
    }
    .institution_describe {
      width: 932px;
      font-family: PingFangSC, PingFang SC;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      margin-top: 92px;
      &.institution_describe_bottom {
        margin-top: 42px;
      }
    }
    .institution_describe a {
      color: inherit; /* 继承父元素的字体颜色 */
      text-decoration: none; /* 默认状态下没有下划线 */
    }
    .institution_describe a:hover {
      text-decoration: underline; /* 鼠标悬停时显示下划线 */
    }
    .button_group {
      margin-top: pxToViewport.pxtovw(39px);
      display: flex;
      align-items: center;
      text-decoration: none !important;
      flex-shrink: 0;
      .btn {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #ffffff;
        line-height: 30px;
        text-align: right;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        /* 添加过渡效果 */
        transition: background-color 0.3s ease, color 0.3s ease;
        &.lf {
          width: 290px;
          height: 60px;
          background: rgba(255, 255, 255, 0.15);
          border: 2px solid #ffffff;
        }
        &.rt {
          width: 290px;
          height: 60px;
          background: rgba(255, 255, 255, 0.15);
          border: 2px solid #ffffff;
          margin-left: 24px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.35);
        }
      }
      &:hover {
        text-decoration: none !important;
      }
    }
    .arrow {
      background: url("../assets/images/down.png") no-repeat;
      background-size: 100% 100%;
      width: 42px;
      height: 43px;
      cursor: pointer;
      margin-top: 69px;
      display: block;
      margin-left: auto;
      margin-right: auto;
      /* 动画保留 */
      animation: moveArrow 1.2s infinite alternate ease-in-out;
      z-index: 1;
      margin-bottom: 40px;
    }
  }
  .news_column {
    background: url("../assets/images/column.svg") no-repeat center center;
    background-size: 100% auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title {
      margin-top: pxToViewport.pxtovw(53px);
      margin-bottom: pxToViewport.pxtovw(47px);
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      text-align: left;
      font-style: normal;
      display: flex;
      align-items: center;
      // line-height: 1;
      line-height: 1.2;
      overflow: hidden;
    }
    .new_list {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      li {
        display: flex;
        align-items: center;
        .order {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          height: 100%;
          flex-shrink: 0;
          .num {
            margin-left: pxToViewport.pxtovw(200px);
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 50px;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            overflow: hidden;
            display: flex;
            align-items: center;
            line-height: 1;
          }
          .numDate {
            margin-left: pxToViewport.pxtovw(200px);
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            text-align: left;
            font-style: normal;
            margin-top: 4px;
          }
        }
        .info {
          // margin-left: pxToViewport.pxtovw(65px);
          margin-left: pxToViewport.pxtovw(100px);
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #efefef;
          text-align: left;
          font-style: normal;
          width: pxToViewport.pxtovw(1070px);
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .card_flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    .titleInfo {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      height: 62px;
      text-align: left;
      font-style: normal;
      margin-bottom: 48px;
      margin-top: 54px;
    }
    .card_list {
      display: grid;
      overflow: hidden !important;
      grid-template-rows: repeat(2, auto);
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 35px;

      grid-row-gap: 35px;
      width: 1227px;
      height: 975px;
      // height: 1100px;
      .item {
        width: 596px;
        height: auto;
        padding-bottom: 30px;

        background: rgba(27, 34, 46, 0.5);
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:nth-child(-n + 2) .text {
          height: 250px; // 精确减半高度
          -webkit-line-clamp: 10; // 显示行数减半[1](@ref)
        }
        .iconImg {
          margin-top: 34px;
          width: 135px;
          height: 129px;
          animation: bounceFall 3s infinite;
          flex-shrink: 0;
        }
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #ffffff;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          margin-top: 14px;
          flex-shrink: 0;
        }
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #a9abae;
          line-height: 32px;
          text-align: left;
          font-style: normal;
          margin-top: 17px;
          width: 562px;
          height: 250px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 10; /* 设置允许显示的行数，这里设为3行，可按需调整 */
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .leaderboardShort {
    margin: 60px auto 0px;
    width: 1200px;
    position: relative;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      text-align: left;
      font-style: normal;
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      padding: 0 20px;
    }
    .tabList {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 11px;
      margin-bottom: 45px;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 87px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #d0d0d0;
        text-align: left;
        font-style: normal;
        border: 1px solid rgba(208, 208, 208, 1);
        cursor: pointer;
        &:nth-child(1) {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          border-right-color: transparent;
          b {
            background: url("../assets/images/fill_1.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &:nth-child(2) {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-left-color: transparent;
          b {
            background: url("../assets/images/fill_4.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &.active {
          color: rgba(255, 98, 31, 1);
          border: 1px solid rgba(255, 98, 31, 1);
          &:nth-child(1) {
            b {
              background: url("../assets/images/fill_2.png") no-repeat;
            }
          }
          &:nth-child(2) {
            b {
              background: url("../assets/images/fill_3.png") no-repeat;
            }
          }
        }
      }
    }
    .board_tabs_Short {
      width: 100%;
      .item {
        width: 100%;
        // height: 782px;
        height: 682px;
        // height: auto;
        overflow: hidden !important;
      }
    }
  }

  .leaderboardMedium {
    margin: 60px auto 0px;
    width: 1200px;
    position: relative;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      text-align: left;
      font-style: normal;
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      padding: 0 20px;
    }
    .tabList {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 11px;
      margin-bottom: 45px;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 87px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #d0d0d0;
        text-align: left;
        font-style: normal;
        border: 1px solid rgba(208, 208, 208, 1);
        cursor: pointer;
        &:nth-child(1) {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          border-right-color: transparent;
          b {
            background: url("../assets/images/fill_1.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &:nth-child(2) {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-left-color: transparent;
          b {
            background: url("../assets/images/fill_4.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &.active {
          color: rgba(255, 98, 31, 1);
          border: 1px solid rgba(255, 98, 31, 1);
          &:nth-child(1) {
            b {
              background: url("../assets/images/fill_2.png") no-repeat;
            }
          }
          &:nth-child(2) {
            b {
              background: url("../assets/images/fill_3.png") no-repeat;
            }
          }
        }
      }
    }
    .board_tabs_Medium {
      width: 100%;
      .item {
        width: 100%;
        height: 682px;
        overflow: hidden !important;
      }
    }
  }

  .leaderboardLong {
    margin: 60px auto 0px;
    width: 1200px;
    position: relative;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      text-align: left;
      font-style: normal;
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      padding: 0 20px;
    }
    .tabList {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 11px;
      margin-bottom: 45px;
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 87px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #d0d0d0;
        text-align: left;
        font-style: normal;
        border: 1px solid rgba(208, 208, 208, 1);
        cursor: pointer;
        &:nth-child(1) {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          border-right-color: transparent;
          b {
            background: url("../assets/images/fill_1.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &:nth-child(2) {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-left-color: transparent;
          b {
            background: url("../assets/images/fill_4.png") no-repeat;
            background-size: 100% 100%;
            width: 14px;
            height: 13px;
            margin-right: 5px;
          }
        }
        &.active {
          color: rgba(255, 98, 31, 1);
          border: 1px solid rgba(255, 98, 31, 1);
          &:nth-child(1) {
            b {
              background: url("../assets/images/fill_2.png") no-repeat;
            }
          }
          &:nth-child(2) {
            b {
              background: url("../assets/images/fill_3.png") no-repeat;
            }
          }
        }
      }
    }
    .board_tabs_Long {
      width: 100%;
      .item {
        width: 100%;
        height: 650px;
        overflow: hidden !important;
      }
    }
  }
  .benchmark_example {
    width: 1200px;
    margin: 46px auto 0px;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      height: 62px;
      text-align: left;
      font-style: normal;
      margin-bottom: 48px;
      // margin-top: 54px;
      text-align: center;
    }
    .image-container {
      width: 1100px;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
        object-fit: contain;
        border-radius: 18px;
      }
    }
    .cont_task {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .left_nav {
        width: 254px;
        height: 520px;
        background: #1b222e;
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 30px 0; // 增加上下内边距
        li {
          width: 230px;
          height: 100px;
          line-height: 100px;
          margin: 20px 0px;
          margin-left: 12px;
          border-radius: 32px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 22px;
          color: #d0d0d0;
          text-align: left;
          font-style: normal;
          padding-left: 30px;
          cursor: pointer;
          /* 添加过渡效果 */
          transition: background-color 0.3s ease, color 0.3s ease;
          &.active {
            background: #ff621f;
            color: #ffffff;
          }
          &:hover {
            background: #ff621f;
            color: #ffffff;
            transform: scale(1.02); // 添加微动效
            // box-shadow: 0 4px 12px rgba(255, 98, 31, 0.2);
          }
        }
      }
      .right_box {
        width: 910px;
        // height: 589px;
        height: 520px;
        background: rgba(27, 34, 46, 066);
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        .example_ul {
          width: 850px;
          height: 56px;
          border-radius: 28px;
          border: 1px solid #485263;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin: 30px auto 0px;
          padding: 0px 9px;
          li {
            width: 402px;
            height: 38px;
            border-radius: 28px;
            border: 1px solid #485263;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #b7b7b7;
            text-align: right;
            font-style: normal;
            cursor: pointer;
            /* 添加过渡效果 */
            transition: background-color 0.3s ease, color 0.3s ease;
            &.active {
              border: 1px solid #ff621f;
              color: #ff621f;
            }
            &:hover {
              border: 1px solid #ff621f;
              color: #ff621f;
            }
          }
        }
        .example_inner {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .example_video {
            width: 100%;
            max-width: 519px;
            background: #1b222e;
            border: 1px solid #485263;
            border-radius: 18px;
            position: relative;
            overflow: hidden;
            &::before {
              content: "";
              display: block;
              padding-top: 56.25%;
            }

            video {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .example_choice {
            height: 100%;
            width: 300px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .topic {
              width: 100%;
              font-family: PingFangSC, PingFang SC;
              font-size: 18px;
              color: #ffffff;
              line-height: 28px;
              text-align: left;
              font-style: normal;
              margin-bottom: 40px;
            }
            .topic_option {
              margin-left: 15px;
              li {
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #ffffff;
                line-height: 28px;
                height: 28px;
                width: 270px;
                text-align: left;
                font-style: normal;
                margin-bottom: 23px;
              }
            }
            .truth_success {
              width: 210px;
              height: 38px;
              background: rgba(17, 219, 121, 0.09);
              border-radius: 9px;
              border: 1px solid #11db79;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #11db79;
              text-align: left;
              font-style: normal;
              display: flex;
              align-items: center;
              justify-content: left;
              margin-bottom: 12px;
            }
            .truth_warning {
              width: 210px;
              height: 38px;
              background: rgba(236, 20, 20, 0.09);
              border-radius: 9px;
              border: 1px solid #ec1414;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #ec1414;
              text-align: left;
              font-style: normal;
              display: flex;
              align-items: center;
              justify-content: left;
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
  .content_text_image {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px auto 0;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      height: 62px;
      text-align: left;
      font-style: normal;
      margin-bottom: 48px;
      margin-top: 54px;
      text-align: center;
    }
    .image-container {
      width: 1100px; // 控制最大显示宽度
      margin: 0 auto; // 水平居中
      img {
        width: 100%; // 自动填充容器宽度
        height: auto; // 保持原始比例
        object-fit: contain; // 自适应包含
        border-radius: 18px;
      }
    }
    .image-container-half {
      width: 900px; // 控制最大显示宽度
      margin: 0 auto; // 水平居中
      img {
        width: 100%; // 自动填充容器宽度
        height: auto; // 保持原始比例
        object-fit: contain; // 自适应包含
        border-radius: 9px;
      }
    }
    .imgColor {
      width: 1200px;
      height: 471px;
      background: #ff621f;
      border-radius: 18px;
      margin-bottom: 29px;
    }
    .news_topic {
      width: 1200px;
      height: 400px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #efefef;
      line-height: 33px;
      text-align: left;
      font-style: normal;
      overflow: hidden;
    }
  }
  .contact_info {
    background: url("../assets/images/Background3.png") no-repeat;
    background-size: 100% 100%;
    width: pxToViewport.pxtovw(1920px);
    height: pxToViewport.pxtovw(360px);
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
    .information {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
      line-height: 62px;
      text-align: left;
      font-style: normal;
    }
    .mail {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 38px;
      color: #ff621f;
      line-height: 53px;
      text-align: left;
      font-style: normal;
    }
  }
  .page_footer {
    .cardInfo {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 214px;
      .NeMoBench {
        margin: 0px 31px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          height: 25px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }
        .text {
          width: 430px;
          height: 112px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #dddddd;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          overflow: hidden;
        }
      }
      .phoenix {
        margin: 0px 31px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          height: 25px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }
        .text {
          width: 430px;
          height: 112px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #dddddd;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          overflow: hidden;
        }
      }
      .friendly {
        margin: 0px 31px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          height: 25px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }
        ul.text {
          li {
            height: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ff8653;
            line-height: 28px;
            text-align: left;
            font-style: normal;
            cursor: pointer;
          }
        }
        a {
          color: inherit; /* 继承父元素的字体颜色 */
          text-decoration: none; /* 默认状态下没有下划线 */
        }
        a:hover {
          text-decoration: underline; /* 鼠标悬停时显示下划线 */
        }
      }
    }
    .footer {
      border-top: 1px solid rgba(255, 255, 255, 0.13);
      height: 70px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: AppleColorEmoji;
      font-size: 16px;
      color: #dedede;
      line-height: 28px;
      text-align: left;
      font-style: normal;
    }
  }
}
::v-deep {
  .el-table.board_table {
    background-color: transparent;
    border-collapse: collapse; // 修改为 collapse 以去掉网格线

    border: none !important; /* 新增：移除表格外边框 */
    font-size: 14px;
    .cell {
      line-height: 23px;
      padding-left: 10px;
      padding-right: 10px;
    }

    & .el-table__cell:first-child .cell {
      padding-left: 10px;
    }
    & .caret-wrapper {
      height: 34px;
    }

    & .sort-caret.ascending {
      top: 5px;
    }
    & .sort-caret.descending {
      bottom: 7px;
    }

    & .sort-caret {
      left: 7px;
    }

    /* 移除所有单元格边框 */
    th.el-table__cell,
    td.el-table__cell {
      border: none !important;
    }

    .el-table__header-wrapper {
      .el-table__header {
        thead {
          color: #e2e2e2;
          tr {
            background: transparent;

            &:first-child {
              th.el-table__cell.is-leaf {
                vertical-align: bottom;
              }
              th.el-table__cell .cell .caret-wrapper {
                width: 20px !important;
              }
            }
            &:last-child {
              th.el-table__cell .cell .caret-wrapper {
                width: 20px !important;
              }
            }
          }
        }
      }
      th.el-table__cell.is-leaf {
        border-bottom: 1px solid transparent;
      }
      th.el-table__cell {
        background-color: transparent;
        padding: 0px;
        .cell {
          display: flex;
          align-items: center;
          justify-content: center; // 添加这一行以使表头内容居中
          height: 58px;
          .caret-wrapper {
            margin-left: 5px;
          }
        }
      }
      .descending .sort-caret.descending {
        border-top-color: rgb(255, 98, 31);
      }
      .ascending .sort-caret.ascending {
        border-bottom-color: rgb(255, 98, 31);
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        color: #e0e0e0;
        tr:nth-child(1) {
          color: #ff401f;
        }
        tr:nth-child(2) {
          color: #ff8653;
        }
        tr:nth-child(3) {
          color: #ffdc3c;
        }
        tr:nth-child(odd) {
          background: rgba(216, 216, 216, 0.1);
          border-radius: 16px 0px 0px 16px;
          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }
        tr:nth-child(even) {
          background: transparent;
          border-radius: 16px 0px 0px 16px;
          td:nth-child(1) {
            border-radius: 16px 0px 0px 16px;
          }
        }
        tr:hover > td.el-table__cell {
          background: rgba(216, 216, 216, 0.2);
          border-bottom: none !important;
        }
        .el-table__cell {
          padding: 24px 0;
          border-bottom: 1px solid transparent;
        }

        tr > .el-table__cell:nth-child(n + 3) {
          // 从第3列开始，居中
          text-align: center !important;
        }
      }
    }
    .el-table--border::after,
    .el-table--group::after,
    &::before {
      background: transparent;
    }

    &::before,
    &::after {
      display: none !important;
    }
  }
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 0;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(216, 216, 216, 0.4);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    background: transparent;
  }
}
@keyframes moveArrow {
  0% {
    transform: translateY(0px); /* 仅垂直移动，无需水平偏移 */
  }
  100% {
    transform: translateY(30px);
  }
}
/* 从上方坠落并弹跳的动画 */
@keyframes bounceFall {
  0% {
    transform: translateY(-300px);
    opacity: 0;
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  12% {
    transform: translateY(0);
    opacity: 1;
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  18% {
    transform: translateY(-20px);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  22% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  26% {
    transform: translateY(-15px);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  29% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  32% {
    transform: translateY(-10px);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  34% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  36% {
    transform: translateY(-6px);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  38% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    transform: translateY(-3px);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  42% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
